import { Route, Routes } from "react-router-dom";

import { HomeScreen } from "../pages/private/200/HomeScreen";
import { BuscarPolizaScreen } from "../pages/private/200/BuscarPolizaScreen";
import { InbountScreen } from "../pages/private/200/InbountScreen";
import { PolizaLayout } from "../layout/PolizaLayout";
import { InformacionScreen } from "../pages/view/tab/InformacionScreen";
import { GenerarCertificadoScreen } from "../pages/view/tab/GenerarCerificadoScreen";
import { SiniestroScreen } from "../pages/view/tab/SiniestroScreen";
import { CancelacionScreen } from "../pages/view/tab/CancelacionScreen";
import { EndosoScreen } from "../pages/view/tab/EndosoScreen";
import { CobranzaScreen } from "../pages/view/tab/CobranzaScreen";
import { ReportesScreen } from "../pages/private/200/ReportesScreen";
import { EquipoScreen } from "../pages/private/200/EquipoScreen";
import { DashboardScreen } from "../pages/private/200/DashboardScreen";
import { CargaBucketScreen } from "../pages/private/200/CargaBucketScreen";
import { ImprimirPDFScreen } from "../pages/private/200/ImprimirPdfScreen";
import { EnvioFisicoScreen } from "../pages/private/200/EnvioFisicoScreen";

export const PrivadaRouter = () => {
  return (
    <Routes>
      <Route path="/inicio" element={<HomeScreen />}></Route>
      <Route path="/inbount" element={<InbountScreen />}></Route>
      <Route path="/reportes" element={<ReportesScreen />}></Route>
      <Route path="/equipo" element={<EquipoScreen />}></Route>
      <Route path="/dashboard" element={<DashboardScreen />}></Route>
      <Route path="/carga-documentos" element={<CargaBucketScreen />}></Route>
      <Route path="/descargar-pdf" element={<ImprimirPDFScreen />}></Route>
      <Route path="/envio-fisico" element={<EnvioFisicoScreen />}></Route>
      <Route path="/ver/*" element={<PolizaLayout />}>
        <Route path="informacion" element={<InformacionScreen />}></Route>
        <Route
          path="generar-certificado"
          element={<GenerarCertificadoScreen />}
        ></Route>
        <Route path="siniestros" element={<SiniestroScreen />}></Route>
        <Route path="cancelacion" element={<CancelacionScreen />}></Route>
        <Route path="endoso" element={<EndosoScreen />}></Route>
        <Route path="cobranza" element={<CobranzaScreen />}></Route>
      </Route>
    </Routes>
  );
};
